import { render, staticRenderFns } from "./SupervisorProjectPicker.vue?vue&type=template&id=4dc09fbb&scoped=true"
import script from "./SupervisorProjectPicker.vue?vue&type=script&lang=js"
export * from "./SupervisorProjectPicker.vue?vue&type=script&lang=js"
import style0 from "./SupervisorProjectPicker.vue?vue&type=style&index=0&id=4dc09fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc09fbb",
  null
  
)

export default component.exports